import React from "react";
import Link from "next/link";

export default () => (
  <footer className="main-footer">
    <ul>
      <li>
        <Link href="/terms-of-service">
          <a target="_blank">Privacy Policy</a>
        </Link>
      </li>
      <li>
        <Link href="/terms-of-service">
          <a target="_blank">Terms of Use</a>
        </Link>
      </li>
      <li style={{ color: "#21714b" }}>(C) {new Date().getFullYear()}</li>
    </ul>
  </footer>
);
